import type { GamePhase } from "@dawn/engine";

export const LOG_LEVELS = [
  "trace",
  "debug",
  "info",
  "warn",
  "error",
] as const;

export type LogLevel = (typeof LOG_LEVELS)[number];

export const LOG_CHANNELS = [
  "session",
  "save",
  "economy",
  "map",
  "ui",
  "audio",
] as const;

export type LogChannel = (typeof LOG_CHANNELS)[number];

export interface GameLogContext {
  sessionId?: string;
  turn?: number;
  phase?: GamePhase;
}

export interface LogEntry {
  ts: number;
  level: LogLevel;
  channel: string;
  event: string;
  sessionId?: string;
  turn?: number;
  phase?: GamePhase;
  data?: Record<string, unknown>;
}
